import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { CMSBreadcrumbRawData } from '@/Shared/AutoGenerated/Main'

export default class CMSBreadcrumb {
    constructor(
        public readonly title: string,
        public readonly url: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: CMSBreadcrumbRawData): CMSBreadcrumb {
        return new CMSBreadcrumb(entityData.title, entityData.url)
    }

    static hydrateMultiple(
        entitiesData: CMSBreadcrumbRawData[],
    ): CMSBreadcrumb[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
